'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ASSIGNED_AGENT_ID = exports.ASSIGNED_AGENT_ID = ['assignedAgentId'];
var ASSIGNED_AGENT_TYPE = exports.ASSIGNED_AGENT_TYPE = ['assignedAgentType'];
var CHANNEL = exports.CHANNEL = ['channel'];
var AGENT_CHANNEL = exports.AGENT_CHANNEL = ['agentChannel'];
var THREAD_ID = exports.THREAD_ID = ['threadId'];
var LATEST_EMAIL_MESSAGE = exports.LATEST_EMAIL_MESSAGE = ['latestEmailMessage'];
var LATEST_MESSAGE = exports.LATEST_MESSAGE = ['latestMessage'];
var LATEST_MESSAGE_TIMESTAMP = exports.LATEST_MESSAGE_TIMESTAMP = ['latestMessage', 'timestamp'];
var LATEST_EMAIL_PREVIEW_TEXT = exports.LATEST_EMAIL_PREVIEW_TEXT = ['latestEmailMessage', 'previewText'];
var LATEST_EMAIL_SUBJECT = exports.LATEST_EMAIL_SUBJECT = ['latestEmailMessage', 'subject'];
var LATEST_EMAIL_TIMESTAMP = exports.LATEST_EMAIL_TIMESTAMP = ['latestEmailMessage', 'timestamp'];
var UNSEEN_COUNT = exports.UNSEEN_COUNT = ['unseenCount'];
var RESPONDER = exports.RESPONDER = ['responder'];
var SOURCE = exports.SOURCE = ['source'];
var STATUS = exports.STATUS = ['status'];
var ASSIGNEE = exports.ASSIGNEE = ['assignedAgentId'];
var WELCOME_MESSAGE_ID = exports.WELCOME_MESSAGE_ID = ['welcomeMessageId'];
var LATEST_SESSION_START_TIME = exports.LATEST_SESSION_START_TIME = ['latestSessionStartedAt'];
var LATEST_SESSION_END_TIME = exports.LATEST_SESSION_END_TIME = ['latestSessionEndedAt'];
var LATEST_READ_TIMESTAMP = exports.LATEST_READ_TIMESTAMP = ['latestReadTimestamp'];
var LATEST_MESSAGE_SEEN = exports.LATEST_MESSAGE_SEEN = ['latestMessageSeen'];
var FILTERED = exports.FILTERED = ['filtered'];
var VISITOR = exports.VISITOR = ['visitor'];
var FILTER_SOURCE = exports.FILTER_SOURCE = ['filteredSource'];
var VID = exports.VID = ['vid'];
var INBOX_ID = exports.INBOX_ID = ['inboxId'];
var THREAD_PREVIEW = exports.THREAD_PREVIEW = ['threadPreview'];